var _defs, _g, _path, _g2, _path2, _path3, _g3, _path4, _g4, _path5, _path6, _g5, _g6, _g7, _path7, _g8, _path8, _g9, _path9, _g10;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "KloekeKip-Logo",
    width: 310.516,
    height: 159.197,
    viewBox: "0 0 310.516 159.197",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 310.516,
    height: 159.197
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 274.63,
    height: 132.647
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M14.381,0A14.405,14.405,0,0,0,0,14.381V144.77a14.376,14.376,0,0,0,14.381,14.381H296.09a14.376,14.376,0,0,0,14.381-14.381V14.381A14.337,14.337,0,0,0,296.136,0Z",
    transform: "translate(0 0)",
    fill: "#46a078"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M376.9,91.9c.046.183.137.412.183.6.5-.046.962-.137,1.466-.183,7.832-.687,13.511,6.274,10.946,13.6-1.695,4.855-3.847,9.572-5.358,14.472-1.282,4.03.458,8.244,3.71,9.389a18.466,18.466,0,0,0,7.19,1.1c2.519-.183,3.435.733,4.03,2.885,1.282,4.534,2.565,9.114,4.076,13.556,3.206,9.572,8.473,12.641,18.32,10.4,5.267-1.191,10.442-2.931,15.617-4.488,11.45-3.435,22.945-6.778,34.349-10.4,5.816-1.832,7.923-5.084,7.877-10.9a18.023,18.023,0,0,0-.55-4.946c-2.977-10.488-5.908-21.022-9.068-31.464-3.023-9.893-11.129-15.159-21.342-13.373-7.557,1.328-14.93,3.618-22.4,5.45-3.3.824-3.847.137-3.664-3.114.229-3.893.092-7.832-.046-11.77-.046-1.1-.687-2.2-1.282-3.847-1.374,1.74-2.244,2.977-3.252,4.168a17.326,17.326,0,0,1-2.748,2.748c-1.557,1.053-3.572,1.466-4.763-.137-.779-1.053-.641-2.84-.6-4.305.046-1.191.87-2.336.87-3.527a3.007,3.007,0,0,0-1.282-2.244c-.366-.229-1.6.366-2.107.916-1.053,1.145-1.878,2.519-2.84,3.756-3.023,3.939-6.32,3.664-8.381-.87A37.335,37.335,0,0,1,394.122,63l-.687-.412a53.7,53.7,0,0,0-3.71,5.954c-1.008,2.2-1.282,4.763-2.29,6.961-.55,1.145-2.015,2.7-3.023,2.656-1.191-.046-2.611-1.374-3.435-2.519-.641-.916-.5-2.336-.641-3.572-.137-.87-.183-1.786-.275-2.885-3.435,2.336-4.259,6.412-1.969,9.572,1.878,2.611,4.168,4.9,6.183,7.374.55.687,1.191,1.786,1.008,2.427s-1.328,1.191-2.153,1.466c-2.153.687-4.214,1.237-6.229,1.878m.6-5.587c-2.473-3.618-5.358-6.778-5.5-11.358a12.019,12.019,0,0,1,3.664-8.977c2.885-2.84,6.045-2.107,8.793,1.74a58.511,58.511,0,0,1,3.343-5.725,10.927,10.927,0,0,1,3.893-3.343c4.351-2.061,7.374-.046,7.6,4.809.046,1.237.321,2.473.458,3.71.229.046.412.046.641.092.733-1.053,1.511-2.107,2.244-3.16,1.649-2.336,3.664-4.168,6.778-3.527a6.568,6.568,0,0,1,5.633,5.816c.046.321.183.641.229,1.008.229-.092.412-.092.5-.183,4.442-4.626,8.61-3.8,10.259,2.427,1.053,3.939,1.145,8.061,1.694,12.411,4.076-1.053,8.427-2.153,12.778-3.343,5.45-1.466,10.992-2.427,16.579-1.145,8.7,2.015,14.152,7.74,16.808,16.075,3.069,9.664,5.816,19.419,8.564,29.174a36.461,36.461,0,0,1,1.145,6.687c.87,9.48-2.382,14.885-12.137,18.182-9.343,3.114-18.915,5.725-28.35,8.473-7.19,2.107-14.381,4.351-21.663,6.045-5.725,1.328-11.5,1.145-16.4-2.977-3.389-2.885-5.175-6.778-6.595-10.809-1.237-3.481-2.244-7.007-3.16-10.534-.458-1.74-1.237-2.244-3.023-2.336-8.839-.458-13.969-5.862-13.19-14.106a35.3,35.3,0,0,1,2.244-8.29c1.053-3.023,2.427-6,3.71-8.931.733-1.695,1.191-3.252-.5-4.763-1.969-1.74-3.939-3.252-6.778-2.244-.55.229-1.1.55-1.649.824-2.931,1.511-4.992.366-5.13-2.931a7.552,7.552,0,0,1,3.389-6.961c1.008-.6,2.015-1.145,3.114-1.832",
    transform: "translate(-201.079 -31.354)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M494.972,166.32a5.682,5.682,0,0,1,2.29,3.206,5.558,5.558,0,0,1,.137,3.206,4.523,4.523,0,0,1-1.74,2.336,11,11,0,0,1-3.526,1.6l-4.168,1.282-3.114-10.167,4.168-1.282c2.794-.824,4.763-.87,5.954-.183m8.015,9.755c1.374-2.336,1.557-5.175.55-8.564a13.048,13.048,0,0,0-2.015-4.076,8.613,8.613,0,0,0-3.069-2.565,8.464,8.464,0,0,0-3.847-.87,21.958,21.958,0,0,0-5.633,1.053L481,163.481a4.3,4.3,0,0,0-2.7,1.878,4.753,4.753,0,0,0,.046,3.481l7.832,25.6a4.819,4.819,0,0,0,1.786,2.748,3.046,3.046,0,0,0,4.442-1.42,4.914,4.914,0,0,0-.046-3.343l-2.885-9.389,5.679-1.74c3.847-1.145,6.412-2.885,7.832-5.221M477.8,200.257a2.9,2.9,0,0,0,2.519.366,3.047,3.047,0,0,0,1.969-1.695,4.694,4.694,0,0,0-.092-3.343l-8.015-26.151a4.8,4.8,0,0,0-1.786-2.794,2.968,2.968,0,0,0-2.565-.321,2.856,2.856,0,0,0-1.924,1.695,4.829,4.829,0,0,0,.092,3.3l8.015,26.151a4.952,4.952,0,0,0,1.786,2.794m-34.3-24.823a2.968,2.968,0,0,0-2.565-.321,2.774,2.774,0,0,0-1.923,1.695,4.828,4.828,0,0,0,.092,3.3l7.557,24.686a22.141,22.141,0,0,0,.824,2.382,4.973,4.973,0,0,0,.824,1.374,3.138,3.138,0,0,0,1.511.87,3.344,3.344,0,0,0,1.649,0,3.159,3.159,0,0,0,1.969-1.695,4.914,4.914,0,0,0-.046-3.343l-2.107-6.87,3.481-6.824,11.083,9.984c.458.458.962.962,1.557,1.511a5.208,5.208,0,0,0,1.878,1.191,3.578,3.578,0,0,0,2.29-.046,3.064,3.064,0,0,0,1.924-1.466,2.729,2.729,0,0,0,.229-2.153,5.184,5.184,0,0,0-1.1-1.924,15.858,15.858,0,0,0-2.153-2.015l-12.824-10.854,5.175-10.076a4.325,4.325,0,0,0,.5-3.343,3,3,0,0,0-3.893-2.015,3.089,3.089,0,0,0-1.511.962,16.515,16.515,0,0,0-1.053,1.924l-7.969,17.5-3.572-11.633a4.683,4.683,0,0,0-1.832-2.794",
    transform: "translate(-237.811 -86.722)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M428.3,162.076a.487.487,0,0,0-.366-.046.469.469,0,0,0-.275.229.776.776,0,0,0,0,.458l.962,3.16a1.8,1.8,0,0,0,.183.412.958.958,0,0,0,.275.183,1.268,1.268,0,0,0,.412-.046l4.168-1.282c.229-.092.412-.183.458-.321a.672.672,0,0,0,0-.6l-1.008-3.252a.475.475,0,0,0-.275-.366.346.346,0,0,0-.366-.046.469.469,0,0,0-.275.229.776.776,0,0,0,0,.458l.87,2.794-1.557.5-.779-2.473a.565.565,0,0,0-.229-.366.487.487,0,0,0-.366-.046c-.137.046-.229.092-.275.229a.764.764,0,0,0,0,.458l.779,2.473-1.374.412-.824-2.7a.47.47,0,0,0-.137-.458M431,170.5a4.368,4.368,0,0,1-.183-.962,1.256,1.256,0,0,1,.321-.824,2.428,2.428,0,0,1,1.145-.641,2.229,2.229,0,0,1,1.832.092.777.777,0,0,1,.275.275,1.146,1.146,0,0,1,.183.321,2.843,2.843,0,0,1,.137.458l.275.916-3.755,1.145Zm-.183,2.061a.662.662,0,0,0,.6,0l4.076-1.237a1.8,1.8,0,0,0,.412-.183.377.377,0,0,0,.183-.275.99.99,0,0,0-.046-.5l-.458-1.557c-.092-.275-.183-.5-.275-.733a1.648,1.648,0,0,0-.366-.55,1.862,1.862,0,0,0-.458-.412,2.554,2.554,0,0,0-.733-.321,2.5,2.5,0,0,0-.824-.046,3.6,3.6,0,0,0-.916.183,2.86,2.86,0,0,0-1.969,1.6,1.557,1.557,0,0,0-.137.916,3.627,3.627,0,0,0,.229,1.1l.458,1.557a.564.564,0,0,0,.229.458",
    transform: "translate(-231.778 -87.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M500.038,124.464a.775.775,0,0,0,.046-.641.921.921,0,0,0-.412-.5,1.119,1.119,0,0,0-.779,0l-5.13,1.557a1.673,1.673,0,0,0-.641.321,1.044,1.044,0,0,0-.275.55,1.635,1.635,0,0,0,.092.779l2.382,7.786a1.535,1.535,0,0,0,.6.916,1.453,1.453,0,0,0,1.008.046l5.267-1.6a.985.985,0,0,0,.641-.458.866.866,0,0,0,.046-.687,1.035,1.035,0,0,0-.412-.55,1.119,1.119,0,0,0-.779,0l-4.534,1.374-.916-2.931,4.03-1.237a.873.873,0,0,0,.6-.412,1.006,1.006,0,0,0,.046-.641.766.766,0,0,0-.412-.5.993.993,0,0,0-.733,0l-4.03,1.237-.779-2.519,4.351-1.328a1.429,1.429,0,0,0,.733-.55m-15.572,3.389a1.006,1.006,0,0,0-.824-.092.894.894,0,0,0-.6.55,1.549,1.549,0,0,0,.046,1.008l2.336,7.694c.092.321.183.6.229.733a.885.885,0,0,0,.229.412.951.951,0,0,0,.458.275.936.936,0,0,0,.5,0,.894.894,0,0,0,.6-.55,1.631,1.631,0,0,0,0-1.053l-.641-2.153,1.1-2.107,3.435,3.114c.137.137.321.275.5.458a1.616,1.616,0,0,0,.6.366,1.325,1.325,0,0,0,.733,0,.891.891,0,0,0,.6-.458.734.734,0,0,0,.046-.687,1.508,1.508,0,0,0-.321-.6,4.844,4.844,0,0,0-.687-.641l-3.984-3.389,1.6-3.114a1.276,1.276,0,0,0,.137-1.053.805.805,0,0,0-.458-.55.906.906,0,0,0-.779-.046.7.7,0,0,0-.458.321,2.309,2.309,0,0,0-.321.6l-2.519,5.45-1.1-3.618a1.24,1.24,0,0,0-.458-.87m-3.252,2.382a.774.774,0,0,0,.046-.641.921.921,0,0,0-.412-.5,1.119,1.119,0,0,0-.779,0l-5.13,1.557a1.674,1.674,0,0,0-.641.321,1.045,1.045,0,0,0-.275.55,1.635,1.635,0,0,0,.092.779l2.382,7.786a1.536,1.536,0,0,0,.6.916,1.453,1.453,0,0,0,1.008.046l5.267-1.6a.985.985,0,0,0,.641-.458.866.866,0,0,0,.046-.687,1.036,1.036,0,0,0-.412-.55,1.119,1.119,0,0,0-.779,0l-4.534,1.374-.916-2.931,4.03-1.237a.873.873,0,0,0,.6-.412,1.006,1.006,0,0,0,.046-.641.766.766,0,0,0-.412-.5.993.993,0,0,0-.733,0l-4.03,1.237-.779-2.519,4.351-1.328c.458-.229.641-.366.733-.55m-9.206,9.16a3.178,3.178,0,0,1-.6,1.557,2.292,2.292,0,0,1-1.237.824,2.443,2.443,0,0,1-1.145.092,2.27,2.27,0,0,1-1.1-.458,4.071,4.071,0,0,1-.962-1.008,6.569,6.569,0,0,1-.687-1.511,5.639,5.639,0,0,1-.275-1.649,3,3,0,0,1,.229-1.328,2.729,2.729,0,0,1,.641-.962,1.979,1.979,0,0,1,1.008-.55,2.273,2.273,0,0,1,1.557,0,2.715,2.715,0,0,1,1.374.962,6.014,6.014,0,0,1,.962,1.878,5.174,5.174,0,0,1,.229,2.153m-6.458-5.679a4.143,4.143,0,0,0-1.145,1.511,4.594,4.594,0,0,0-.412,1.969,7.016,7.016,0,0,0,.366,2.29,7.123,7.123,0,0,0,.962,2.061,4.66,4.66,0,0,0,1.42,1.42,4.178,4.178,0,0,0,1.832.641,5.1,5.1,0,0,0,2.152-.229,4.935,4.935,0,0,0,1.878-1.008,4.305,4.305,0,0,0,1.145-1.557,4.715,4.715,0,0,0,.366-1.969,8.5,8.5,0,0,0-.366-2.29,6.411,6.411,0,0,0-1.42-2.656,4.3,4.3,0,0,0-2.2-1.374,4.748,4.748,0,0,0-2.748.137,7.7,7.7,0,0,0-1.832,1.053m-8.061,2.382a1.006,1.006,0,0,0-.824-.092.894.894,0,0,0-.6.55,1.689,1.689,0,0,0,.046,1.053l2.427,7.969a1.535,1.535,0,0,0,.6.916,1.452,1.452,0,0,0,1.008.046l4.671-1.42a.883.883,0,0,0,.641-.458.734.734,0,0,0,.046-.687,1.069,1.069,0,0,0-.458-.55,1.126,1.126,0,0,0-.779-.046l-3.939,1.191-2.29-7.511a1.719,1.719,0,0,0-.55-.962m-9.847,3.023a1.006,1.006,0,0,0-.824-.092.894.894,0,0,0-.6.55,1.548,1.548,0,0,0,.046,1.008l2.336,7.694c.092.321.183.6.229.733a.886.886,0,0,0,.229.412.951.951,0,0,0,.458.275.937.937,0,0,0,.5,0,.894.894,0,0,0,.6-.55,1.632,1.632,0,0,0,0-1.053l-.641-2.153,1.1-2.107,3.435,3.114c.137.137.321.275.5.458a1.617,1.617,0,0,0,.6.366,1.326,1.326,0,0,0,.733,0,.874.874,0,0,0,.641-1.145,1.509,1.509,0,0,0-.321-.6,4.843,4.843,0,0,0-.687-.641L452,142l1.6-3.114a1.276,1.276,0,0,0,.137-1.053.805.805,0,0,0-.458-.55.906.906,0,0,0-.779-.046.7.7,0,0,0-.458.321,2.312,2.312,0,0,0-.321.6l-2.519,5.45-1.1-3.618a1.151,1.151,0,0,0-.458-.87",
    transform: "translate(-241.824 -66.803)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M178.361,106.126h13.877c.412,0,.6-.183.6-.6V102.05c0-.412-.183-.6-.6-.6h-9.206V97.928h6.778c.458,0,.641-.183.641-.6v-2.84a.579.579,0,0,0-.641-.641h-6.778V90.463h8.931c.412,0,.6-.183.6-.6V86.341c0-.412-.183-.6-.6-.6h-13.6c-.412,0-.6.183-.6.6v19.19a.532.532,0,0,0,.6.6m-4.122-20.152c0-.137-.092-.183-.321-.183h-4.946a1.887,1.887,0,0,0-.55.046,1.077,1.077,0,0,0-.458.366L162.057,93.9V86.387a.5.5,0,0,0-.275-.458,1.055,1.055,0,0,0-.412-.137h-4.076a.532.532,0,0,0-.6.6v19.144c0,.412.183.6.6.6h4.122c.412,0,.6-.183.6-.6V101l2.015-2.427,4.488,6.961a1.247,1.247,0,0,0,.366.458.823.823,0,0,0,.5.137h5.221c.412,0,.5-.229.183-.641l-7.282-10.946,6.549-8.106a.74.74,0,0,0,.183-.458M146.531,101a1.59,1.59,0,0,1-1.145.458,1.744,1.744,0,0,1-.733-.137,4.83,4.83,0,0,1-.5-.321,2.516,2.516,0,0,0-.412-.321.731.731,0,0,0-.366-.137,1.986,1.986,0,0,0-.229.046c-.092.046-.137.092-.229.137l-2.382,2.244a.591.591,0,0,0-.229.5c0,.137,0,.183.046.229a5.969,5.969,0,0,0,2.336,2.061,6.895,6.895,0,0,0,5.587.183,6.773,6.773,0,0,0,2.153-1.42,7.336,7.336,0,0,0,1.466-2.061,5.94,5.94,0,0,0,.55-2.519V86.479a.654.654,0,0,0-.733-.733h-4.122c-.366,0-.5.183-.5.55V99.9a1.434,1.434,0,0,1-.55,1.1m-12.915,5.129h4.122c.412,0,.6-.183.6-.6V86.387c0-.412-.183-.6-.6-.6h-4.122a.532.532,0,0,0-.6.6v19.144a.532.532,0,0,0,.6.6m-16.579,0h12.32a.532.532,0,0,0,.6-.6v-3.664c0-.412-.183-.6-.6-.6h-7.6V86.387c0-.412-.183-.6-.6-.6h-4.122a.739.739,0,0,0-.412.137.482.482,0,0,0-.183.458v19.144c.046.366.229.6.6.6M106.548,90.234a2.361,2.361,0,0,1,.779.6,2.493,2.493,0,0,1,.5.824,2.124,2.124,0,0,1,.183.87,2.183,2.183,0,0,1-.183.916,2.286,2.286,0,0,1-.5.779,2.4,2.4,0,0,1-.779.55,2.33,2.33,0,0,1-1.008.183h-3.023V90.005h3.023a2.183,2.183,0,0,1,1.008.229M97.8,106.126h4.122c.412,0,.6-.183.6-.6V99.348h2.2l3.252,6.183a.973.973,0,0,0,.321.458c.092.092.229.092.458.092h4.946c.183,0,.321-.046.366-.183a.445.445,0,0,0-.046-.412L110.075,98.2A7.37,7.37,0,0,0,112.5,95.73a6.151,6.151,0,0,0,.916-3.16,6.812,6.812,0,0,0-.458-2.519,6.726,6.726,0,0,0-1.328-2.2,7.642,7.642,0,0,0-2.061-1.557,5.665,5.665,0,0,0-2.656-.6H97.8a.531.531,0,0,0-.458.183.739.739,0,0,0-.137.412v19.236c.046.366.229.6.6.6m-18.5,0H93.175c.412,0,.6-.183.6-.6V102.05c0-.412-.183-.6-.6-.6H83.97V97.928h6.824c.458,0,.641-.183.641-.6v-2.84a.579.579,0,0,0-.641-.641H84.015V90.463h8.931c.412,0,.6-.183.6-.6V86.341c0-.412-.183-.6-.6-.6h-13.6c-.412,0-.6.183-.6.6v19.19a.5.5,0,0,0,.55.6m-18.5,0H74.672c.412,0,.6-.183.6-.6V102.05c0-.412-.183-.6-.6-.6h-9.16V97.928h6.778c.458,0,.641-.183.641-.6v-2.84a.579.579,0,0,0-.641-.641H65.513V90.463h8.931c.412,0,.6-.183.6-.6V86.341c0-.412-.183-.6-.6-.6H60.8c-.412,0-.6.183-.6.6v19.19a.553.553,0,0,0,.6.6",
    transform: "translate(-32.629 -46.45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M127.991,151.286a3.1,3.1,0,0,1,1.1.916,4.083,4.083,0,0,1,.687,1.237,3.732,3.732,0,0,1,.275,1.42,4.474,4.474,0,0,1-.916,2.7,3.25,3.25,0,0,1-2.656,1.191h-5.038v-7.786h5.038a2.818,2.818,0,0,1,1.511.321M113.472,178.17h6.916c.733,0,1.053-.321,1.053-1.008V166.125h7.145a10,10,0,0,0,7.694-3.527,11.809,11.809,0,0,0,2.153-3.572,11.551,11.551,0,0,0,.779-4.122,11.8,11.8,0,0,0-.779-4.168,12.545,12.545,0,0,0-2.2-3.618,11.055,11.055,0,0,0-3.389-2.565,9.923,9.923,0,0,0-4.351-.962H113.518a.932.932,0,0,0-.687.275,1.007,1.007,0,0,0-.275.779v32.517c-.046.687.275,1.008.916,1.008m-16.442,0h7.007a.879.879,0,0,0,1.008-1.008V144.6a.879.879,0,0,0-1.008-1.008H97.031c-.641,0-.962.321-.962,1.008v32.563c-.046.687.275,1.008.962,1.008m-7.053-34.258c0-.229-.183-.366-.55-.366H81.047a4.727,4.727,0,0,0-.916.092,1.548,1.548,0,0,0-.779.641l-10.03,13.053V144.553a.85.85,0,0,0-.458-.779,1.336,1.336,0,0,0-.687-.275H61.262c-.641,0-.962.321-.962,1.008v32.655c0,.687.321,1.008.962,1.008h7.007a.879.879,0,0,0,1.008-1.008v-7.694l3.389-4.168,7.648,11.862a2.685,2.685,0,0,0,.6.779,1.279,1.279,0,0,0,.824.275h8.793c.733,0,.824-.366.321-1.053l-12.366-18.64,11.129-13.785a1.277,1.277,0,0,0,.366-.824",
    transform: "translate(-32.683 -77.779)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M282.3,204.77h2.656a.607.607,0,0,0,.687-.687v-5.771a1.326,1.326,0,0,1,.458-1.053,1.713,1.713,0,0,1,1.145-.458,1.162,1.162,0,0,1,.733.183,2.156,2.156,0,0,1,.641.55.582.582,0,0,0,.321.183.74.74,0,0,0,.641-.412l1.282-2.015a.774.774,0,0,0,.137-.458.646.646,0,0,0-.366-.55c-.275-.183-.5-.366-.687-.5a4.581,4.581,0,0,0-.641-.366,4.028,4.028,0,0,0-.687-.229,4.611,4.611,0,0,0-.87-.092,2.194,2.194,0,0,0-1.511.55,9.339,9.339,0,0,0-1.053,1.237l-.092-.183c-.046-.092-.092-.229-.137-.321a2.241,2.241,0,0,0-.137-.321.346.346,0,0,1-.046-.183,2.458,2.458,0,0,1-.229-.5.429.429,0,0,0-.412-.229h-1.878a.773.773,0,0,0-.458.137.591.591,0,0,0-.229.5v10.259c.046.5.275.733.733.733m-10.351-7.282a1.809,1.809,0,0,1,1.42-.641,1.655,1.655,0,0,1,1.374.641,2.279,2.279,0,0,1,.5,1.557,2.442,2.442,0,0,1-.5,1.557,1.784,1.784,0,0,1-1.374.641,1.809,1.809,0,0,1-1.42-.641,2.279,2.279,0,0,1-.5-1.557,2.136,2.136,0,0,1,.5-1.557m-4.122,3.893a5.474,5.474,0,0,0,1.282,1.878,5.949,5.949,0,0,0,1.878,1.282,5.747,5.747,0,0,0,2.336.458,5.387,5.387,0,0,0,2.29-.458,5.947,5.947,0,0,0,1.878-1.282,6.514,6.514,0,0,0,1.282-1.878,5.746,5.746,0,0,0,.458-2.336,5.99,5.99,0,0,0-1.74-4.305,5.947,5.947,0,0,0-1.878-1.282,5.682,5.682,0,0,0-2.29-.458,5.746,5.746,0,0,0-2.336.458,5.948,5.948,0,0,0-1.878,1.282,6.152,6.152,0,0,0-1.282,1.924,5.815,5.815,0,0,0-.458,2.382,5.6,5.6,0,0,0,.458,2.336m-9.618-3.893a1.809,1.809,0,0,1,1.42-.641,1.655,1.655,0,0,1,1.374.641,2.279,2.279,0,0,1,.5,1.557,2.441,2.441,0,0,1-.5,1.557,1.784,1.784,0,0,1-1.374.641,1.809,1.809,0,0,1-1.42-.641,2.279,2.279,0,0,1-.5-1.557,2.635,2.635,0,0,1,.5-1.557m-4.076,3.893a5.474,5.474,0,0,0,1.282,1.878,5.948,5.948,0,0,0,1.878,1.282,5.746,5.746,0,0,0,2.336.458,5.388,5.388,0,0,0,2.29-.458,6.141,6.141,0,0,0,3.16-3.16,5.747,5.747,0,0,0,.458-2.336,5.99,5.99,0,0,0-1.74-4.305,5.947,5.947,0,0,0-1.878-1.282,5.682,5.682,0,0,0-2.29-.458,5.746,5.746,0,0,0-2.336.458,5.948,5.948,0,0,0-1.878,1.282,6.152,6.152,0,0,0-1.282,1.924,5.814,5.814,0,0,0-.458,2.382,5.6,5.6,0,0,0,.458,2.336m-8.427,3.343a.679.679,0,0,0,.321.046h2.748a.6.6,0,0,0,.55-.321c.092-.229.183-.412.275-.6l3.939-10.03c0-.046.046-.092.046-.183a.662.662,0,0,0-.092-.321.56.56,0,0,0-.412-.137h-3.206a.727.727,0,0,0-.687.5l-1.695,6c-.092-.321-.183-.733-.321-1.191s-.275-1.008-.458-1.557c-.137-.55-.321-1.1-.458-1.649s-.321-1.053-.458-1.557a.635.635,0,0,0-.641-.55H241.9c-.321,0-.5.137-.5.412v.183c0,.046,0,.092.046.092.641,1.649,1.282,3.343,1.924,4.992s1.282,3.3,1.924,4.992a2.321,2.321,0,0,0,.321.687c-.046.092,0,.137.092.183",
    transform: "translate(-130.841 -104.608)",
    fill: "#003e2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M188.537,249.753h3.756c.412,0,.6-.183.6-.55V232.35a.372.372,0,0,0-.183-.366.739.739,0,0,0-.412-.137H188.72a.774.774,0,0,0-.458.137.52.52,0,0,0-.137.366V242.1l-6.412-9.755a1.058,1.058,0,0,0-.916-.55h-4.168a.56.56,0,0,0-.412.137.52.52,0,0,0-.137.366v16.854a.486.486,0,0,0,.55.55H180.2c.412,0,.6-.183.6-.55V238.716l6.732,10.442a1.151,1.151,0,0,0,1.008.6m-29.174,0h12.961a.486.486,0,0,0,.55-.55v-3.069a.486.486,0,0,0-.55-.55h-8.61v-3.069h6.366c.412,0,.6-.183.6-.55v-2.473c0-.366-.183-.55-.6-.55h-6.366v-2.931h8.335a.486.486,0,0,0,.55-.55V232.4a.486.486,0,0,0-.55-.55H159.317a.486.486,0,0,0-.55.55v16.854a.533.533,0,0,0,.6.5m-17.266,0h12.961a.486.486,0,0,0,.55-.55v-3.069a.486.486,0,0,0-.55-.55h-8.61v-3.069h6.366c.412,0,.6-.183.6-.55v-2.473c0-.366-.183-.55-.6-.55h-6.366v-2.931h8.335a.486.486,0,0,0,.55-.55V232.4a.486.486,0,0,0-.55-.55H142.051a.486.486,0,0,0-.55.55v16.854c0,.321.183.5.6.5m-9.847-13.969a4.149,4.149,0,0,1,.733.5,2.461,2.461,0,0,1,.458.733,2.715,2.715,0,0,1,.183.779,2.274,2.274,0,0,1-.641,1.511,2.952,2.952,0,0,1-.733.5,2.051,2.051,0,0,1-.916.183h-2.84v-4.442h2.84a2.085,2.085,0,0,1,.916.229M124.1,249.753h3.847a.486.486,0,0,0,.55-.55v-5.4h2.061l3.069,5.45a.783.783,0,0,0,.275.412.914.914,0,0,0,.412.092h4.626c.183,0,.321-.046.366-.183a.367.367,0,0,0-.046-.366l-3.664-6.412a6.736,6.736,0,0,0,2.244-2.153,5.273,5.273,0,0,0,.87-2.794,5.864,5.864,0,0,0-.412-2.2,5.34,5.34,0,0,0-1.237-1.924,7.335,7.335,0,0,0-1.924-1.374,5.437,5.437,0,0,0-2.473-.5h-8.519a.446.446,0,0,0-.412.183.52.52,0,0,0-.137.366v16.854c-.046.321.137.5.5.5m-17.312,0h12.961a.486.486,0,0,0,.55-.55v-3.069a.486.486,0,0,0-.55-.55h-8.61v-3.069H117.5c.412,0,.6-.183.6-.55v-2.473c0-.366-.183-.55-.6-.55h-6.366v-2.931h8.335a.486.486,0,0,0,.55-.55V232.4a.486.486,0,0,0-.55-.55H106.74a.486.486,0,0,0-.55.55v16.854a.533.533,0,0,0,.6.5m-8.793-7.1a4.129,4.129,0,0,1-1.053,1.466,6.069,6.069,0,0,1-1.557,1.008,5.573,5.573,0,0,1-1.969.366H91.626v-9.343h1.786a5.385,5.385,0,0,1,1.969.366,4.572,4.572,0,0,1,1.557,1.008,4.787,4.787,0,0,1,1.053,1.466,4.841,4.841,0,0,1,.366,1.832,4.23,4.23,0,0,1-.366,1.832m-10.763,7.1h6.641a9.1,9.1,0,0,0,3.71-.733,10.441,10.441,0,0,0,3.023-1.969,9.45,9.45,0,0,0,2.015-2.84,7.927,7.927,0,0,0,.733-3.389,7.5,7.5,0,0,0-.824-3.481,8.8,8.8,0,0,0-2.153-2.84,10.314,10.314,0,0,0-3.023-1.924,9.243,9.243,0,0,0-3.481-.687H87.23a.486.486,0,0,0-.55.55V249.3c0,.275.183.458.55.458m-17.312,0H82.879a.486.486,0,0,0,.55-.55v-3.069a.486.486,0,0,0-.55-.55h-8.61v-3.069h6.366c.412,0,.6-.183.6-.55v-2.473c0-.366-.183-.55-.6-.55H74.269v-2.931H82.6a.486.486,0,0,0,.55-.55V232.4a.486.486,0,0,0-.55-.55H69.918a.486.486,0,0,0-.55.55v16.854c-.046.321.137.5.55.5m-9.068,0H64.7a.486.486,0,0,0,.55-.55V232.35a.486.486,0,0,0-.55-.55H60.85a.486.486,0,0,0-.55.55V249.2c.046.366.183.55.55.55",
    transform: "translate(-32.683 -125.638)",
    fill: "#003e2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M241.8,156.343v4.076c0,.412.458.6,1.328.6h41.723c.87,0,1.328-.183,1.328-.6v-4.076c0-.366-.458-.55-1.328-.55H243.128c-.87-.046-1.328.183-1.328.55",
    transform: "translate(-131.058 -84.438)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M332.348,148.438h0l-10.671-10.671c-.412-.412-.733-.458-1.008-.229l-2.885,2.885c-.275.275-.229.641.183,1.053l7.007,7.007-7.007,7.007c-.412.412-.458.733-.229,1.008l2.885,2.885c.275.275.641.229,1.053-.183l10.671-10.763Z",
    transform: "translate(-172.143 -74.473)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M618.186,313.15c1.191.046.779-.458.916-.55-1.969.092-.87.687-.916.55",
    transform: "translate(-334.92 -169.433)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M572.974,316.143l.389-.243-3.063.535Z",
    transform: "translate(-312.154 -172.118)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M535.9,315.866c1.74.87,6.641-.137,9.893.183l.55.183,1.466-.733c-3.985.137-9.16.641-11.908.366",
    transform: "translate(-290.464 -171.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M514.263,312.1c.6.366-2.107.275,2.29.092a2.919,2.919,0,0,1-.412-.092,12.336,12.336,0,0,1-1.878,0",
    transform: "translate(-278.582 -169.162)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M518.25,312.043c1.924-.046-1.237-.275,0,0",
    transform: "translate(-280.737 -169.059)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M497.737,311.733l2.519-.321c-.55-.183-2.794-.229-1.969-.412-2.565.183-2.015.412-.55.733",
    transform: "translate(-269.109 -168.565)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M494,313.793l1.328-.137a2.482,2.482,0,0,0-1.328.137",
    transform: "translate(-267.753 -169.985)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M499.594,313.1l-2.794.275c.366.137.412.412,1.282-.092-.229.275.321.046,1.511-.183",
    transform: "translate(-269.271 -169.704)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M506.4,313.389c1.42.183,3.252.321.733.641,4.809-.137,4.122-.733-.733-.641",
    transform: "translate(-274.474 -169.855)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M533.8,318.185l1.924.275,1.648-.275c-.824.137-3.664-.275-3.572,0",
    transform: "translate(-289.323 -172.408)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M464.685,311.6c-.137.183.87.5,1.053.733l1.878-.229c-.962-.092-2.794-.229-2.931-.5",
    transform: "translate(-251.857 -168.891)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M463.694,313.2l-2.794.321c2.473.046,2.931-.092,2.794-.321",
    transform: "translate(-249.813 -169.758)",
    fill: "#fff"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M491.973,315.429l4.863-.729-5.835.729Z",
    transform: "translate(-266.378 -171.501)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M439.913,311.086l1.7-.486-3.015.681Z",
    transform: "translate(-237.841 -169.395)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M419.35,310.724c1.191-.366-1.6-.6-.366-.824a31.355,31.355,0,0,0-5.084.641,25.113,25.113,0,0,1,5.45.183",
    transform: "translate(-224.338 -167.969)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M408.5,311.712q1.168-.137,2.473-.412a23.2,23.2,0,0,0-2.473.412",
    transform: "translate(-221.412 -168.728)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M447.8,313.049a5.1,5.1,0,0,0-2.2-.55l1.1.55h1.1",
    transform: "translate(-241.52 -169.378)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M445.227,313.746h0c-1.237-.046-2.061-.046-2.427-.046.321,0,1.053,0,2.427.046",
    transform: "translate(-240.002 -170.029)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M450.675,313.8H450.4a.292.292,0,0,0,.275,0",
    transform: "translate(-244.122 -170.083)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M473.171,315.1c-1.649.275-5.084.6-1.74,1.053,1.191-.321-.733-.6,1.74-1.053",
    transform: "translate(-254.756 -170.788)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M454,314.766l2.977.137c-.046-.137-.6-.366.229-.5Z",
    transform: "translate(-246.073 -170.408)",
    fill: "#fff"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M450.8,315.343l1.556-.195-1.167-.049Z",
    transform: "translate(-244.399 -171.707)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M414.505,313.3a30.48,30.48,0,0,1-4.305.275c1.695.092,3.481.183,5.13.137.275-.137,1.008-.412-.824-.412",
    transform: "translate(-222.333 -169.812)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M433.175,313.6a.58.58,0,0,0-.275.046c.137.046.275.046.275-.046",
    transform: "translate(-234.637 -169.975)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M376.1,313.9c.092.046.183.046.229.092,0-.046.046-.046.046-.092Z",
    transform: "translate(-203.85 -170.137)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M421.7,314.283a9.73,9.73,0,0,0,2.794-.183c-.962.046-1.969.092-3.069.092-.092.092-.137.137.275.092",
    transform: "translate(-228.384 -170.246)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M399,312.75q1.03.138,2.2.275a6.041,6.041,0,0,0-2.2-.275",
    transform: "translate(-216.262 -169.491)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M431.741,313.287a.275.275,0,0,0,.183-.046c-.412-.092-.366-.046-.183.046",
    transform: "translate(-233.935 -169.753)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M429.894,313.4c-.641.092-1.191.229-1.695.321.779-.046,1.511-.092,2.107-.183a4.3,4.3,0,0,1-.412-.137",
    transform: "translate(-232.089 -169.866)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M361.921,317.5c.229-.5,3.572-.962,6.5-.412,2.84-.366,1.008-1.969-1.511-2.885-.092.229-.092.412-3.023.687,1.008.275,6.549.641,4.03,1.053-3.893.275-3.206-.183-5.084-.458,1.6.6-4.946.916-4.122,1.786l3.435-.321c.046.183-1.191.412-.229.55",
    transform: "translate(-194.388 -170.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M382.342,313.433l1.191-.046a23.748,23.748,0,0,1-4.168-.687c-2.015.229-2.427.412-2.565.6l5.954.046Z",
    transform: "translate(-204.23 -169.487)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M397.058,313.721c-.962.55-3.847.779-2.061,1.328,3.572-.046,2.473-.458,4.626-.687-5.725.137,1.649-.321-2.519-.6,1.145-.092,2.153-.137,3.114-.137-1.053-.046-2.015-.137-2.977-.229a.168.168,0,0,1,.137.046h.046c.229.046.321.092.046.046h-.137a.469.469,0,0,1-.275.229c-1.649-.092-.275-.137.275-.183,0-.046.046-.046.092-.092h0l-5.725.275a49.776,49.776,0,0,0,5.358,0",
    transform: "translate(-212.306 -169.866)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M465.824,319.837c-.183-.046-.183-.092-.183-.137-.366.092-.5.137.183.137",
    transform: "translate(-252.218 -173.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M457.749,317.782a5.769,5.769,0,0,1,2.107-.229c1.191.183,0,.275.046.412.824-.137,2.885-.366.275-.641l-.412.092a19.871,19.871,0,0,1-4.9-.916,12.7,12.7,0,0,0,2.885,1.282",
    transform: "translate(-246.524 -171.546)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M426.363,317l-4.763.275,2.427.458-.137-.275c2.7.092,2.107-.229,2.473-.458",
    transform: "translate(-228.512 -171.818)",
    fill: "#fff"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M372.537,312.732l.681-.632-2.918.875Z",
    transform: "translate(-200.8 -170.165)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M359.759,312.935,360,312.4l-1.7.34Z",
    transform: "translate(-194.255 -170.32)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M43.7,299.559c0-.046.046-.046.046-.092s.046-.137.046-.183l.092-.366c.046-.275.137-.5.183-.779.137-.5.229-.962.321-1.374.183-.779.229-1.328-.092-1.191l-.55.641c.046.733.046,1.328.046,1.924,0,.275-.046.55-.046.824,0,.229-.046.6-.046.6",
    transform: "translate(-23.686 -160.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M36.383,76.2a2.963,2.963,0,0,1-.183.6c.183.5.366.962.5,1.374-.092-.55-.183-1.237-.321-1.969",
    transform: "translate(-19.621 -41.301)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M217.1,313.521a34.1,34.1,0,0,0-4.4-.321c2.107.321,3.847.779,4.4.321",
    transform: "translate(-115.286 -169.758)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M194.156,36.721c.87-.092,1.237-.229,1.191-.321-.87.092-1.374.183-1.191.321",
    transform: "translate(-105.214 -19.729)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M201.5,312.932c.321.046.6.092.916.137a39.55,39.55,0,0,1,4.168-.137,14.571,14.571,0,0,0-5.084,0",
    transform: "translate(-109.215 -169.49)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M632.21,290.327c-.046-.6-.046-1.511-.046-2.427a15.079,15.079,0,0,0,.046,2.427",
    transform: "translate(-342.624 -156.045)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M306.7,312.959c1.328-.046.229-.046,0,0",
    transform: "translate(-166.235 -169.609)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M320.049,317.6c-.275.046-.5.137-.55.275a1.542,1.542,0,0,1,.55-.275",
    transform: "translate(-173.172 -172.143)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M172.692,320.6H172.6c.412.092.321.046.092,0",
    transform: "translate(-93.551 -173.769)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M309.095,313.283c-.5-.046-1.053-.137-1.695-.183a7.833,7.833,0,0,0,1.695.183",
    transform: "translate(-166.614 -169.704)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M310.5,312.941c.458,0,.824.046,1.145.046.137-.092,0-.137-1.145-.046",
    transform: "translate(-168.294 -169.59)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(16.484 14.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M302.7,312.945c.727,0,1.455,0,2.136.045-.273-.045-.364-.045-.273-.091-.409.045-.955.045-1.864.045",
    transform: "translate(-180.521 -184.916)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M30.5,219.3a9.44,9.44,0,0,1,.455,4.618l1.545-1.539Z",
    transform: "translate(-32.045 -133.691)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M271.122,27.708l-.864-.136c1.954-.181,1.409,0,.864.136M146.352,153.7c.455-.091.409-.181.227-.226a8.42,8.42,0,0,1-2.454.136,4.8,4.8,0,0,0,2.227.091m-4.409-.226c-.045,0-.091,0-.091.045-2.182-.272-1.409-.181.091-.045M32.355,53.015a7.9,7.9,0,0,1,.136-3.033,17.9,17.9,0,0,1-.136,3.033m51.59-30.377c.955-.136,2.864-.5,3.545-.181-1.091.724-1.909.407-3.545.181m49.317-.362-3.318-.5c4-.77,6.863-.5,3.773-1.177-.455,1.675-12.818.181-13.272,1.856l-2.182-.362c.636,0,.727-.091,1.318-.045-4.227-.815-3.136,1.222-8.591.951-1.909-.136-3.227-.362-1.909-.589l-4.227.407c-1.227-.045-.909-.317.273-.272l-6.454.136.045-.045c-.909.272-3,.679-4.045.86-1.636-.226.818-.181.409-.407L91.49,23.5c-1.455-.453,1.5-.86,4-.77-3.318-1.675-2.954.407-10.182-.543l3.364-.226c-2.182-.951-4.818-.589-8.636-1.177.909.317,7.636,1.494,3.773,1.9a16.572,16.572,0,0,0-4.636.136c0-.589-2.045-.453-4.636-.407l.182-.77c-2.773.226-2.545.634-4.182,1-3.091-.091-3.727-.679-4.454-1.222-4.954-.136,3.409,1-2.454,1.132a60.686,60.686,0,0,0-11.909.5c-2.864-.272.5-.5-.545-.724l-2.545.634c-.636,0-.409-.226-.318-.317-2.136.226-.182.77-3.545,1-.227.226-.773.226-1.545.181-.364-.045-.818-.091-1.273-.136a3.994,3.994,0,0,0-.727-.091,2.956,2.956,0,0,0-.909-.091,8.941,8.941,0,0,0-4.045.86,6.563,6.563,0,0,0-3.182,3.078c-.909,1.087-.045-.86-.5-.679a9.671,9.671,0,0,0-1.318,4.3,13.477,13.477,0,0,0,.136,2.264c.136,1.087.318,2.083.773,4.391l-.5,3.984c.591-2.943,1.318.815,1.864,4.074.273-1.041.545-1.947.636-2.535l.409,5.252c-.136.634-.409.091-.727-.77.091.362.136.679.182.951-.273,1.856-.727.905-1.182-.453.182-.634.318-1.268.5-1.9-.5-1.222-1.045-2.445-1.5-2.173a10.617,10.617,0,0,1,.227,1.72c-.136-.317-.227-.543-.318-.407a5.022,5.022,0,0,0,.273,1.585l-.864,1.177.364.272-.591,6.881c.909,4.889,2.182,9.19,2.545,16.932-.636-1.947-1.045-.407-1.818-.5.818-2.128-.364-6.021-.182-10.05-.091,2.083-.455,1.63-.591,1.087l.727,7.2c-.636-.181-.455,1.539-.727,3.4,1.227-1.4.818,5.342,1.182,8.285-.409.181-.818-.5-.727-4.074-.909,3.939,1.455,5.07.682,8.964a4,4,0,0,0-.136-1.675c.364,2.037.091,7.017-.273,5.84v-.86c-.136,5.795,0,17.611,1.045,18.471a4.747,4.747,0,0,1-1.5-1.087l3.545,10.322c-.909-.905-3.045,2.58-3.545-2.218a25.966,25.966,0,0,0,.045,5.976c.136-.951,1.318-2.354,1.409-1.041-1,3.531-.545,2.445-1.409,6.791.182-1.4,1.591.136,1.545,2.4-.227-.362-1.409.181-1.545-.634l1.409,5.523c-.273-1.4-1.182-.226-1.591,1,.273-.589-.045,4.8.091,6.293l.318-2.354a14.937,14.937,0,0,0,.909,6.2,16.39,16.39,0,0,1,.682,2.49c.091.453.136,1.041.273,1.675a13.685,13.685,0,0,0,.545,2.037c-.273-.317-.818-.679-1.227-.543-.364.136-.773.86.091,2.716a8.538,8.538,0,0,0,5.136,1.947,13.122,13.122,0,0,0,3.5-.543,22.338,22.338,0,0,1,4-.77l1.045.407,4.227-.453c-1.318.543-3.818,1.358-6.5,2.173-.682.181-1.364.407-2.045.589a10.318,10.318,0,0,1-2.182.453,8.645,8.645,0,0,1-4.454-.634,10.8,10.8,0,0,0,1.909,1.268,7.14,7.14,0,0,0,3.227.679c.773.226.182.362-.818.362a12.475,12.475,0,0,1-1.727-.181,12.339,12.339,0,0,1-1.5-.453c.455.181.955.362,1.409.5l1.409.317c.455.091.909.091,1.364.136l.636.045h.5l4.091.136c-.364-.815,6.273-.815,5.954-1.539l-8.818.951c-.364-.815,5.136-2.354,10.954-2.218,1.5.317-1.091,1.494-1,1.766a27.945,27.945,0,0,1,6.045-.362l-2.454.453c3.227.317,5.273-1.087,9.182-.317,1.364.045,4,1.086,4.227.589-2.182-.951-2.636-3.848-1.136-4.572.455.045,7.045.905,8.591,1.358,2.227.724-3.318,1.766-1.455,2.4.091-.226,1.318-.5,1.818-.589,1.409.181-.591.679,2.5.589.5-.86,6.227.091,1.455-.724,3-.226,3.182.181,6.682.136-1.136-.543,3.136-1.856,6.136-2.083-.182.226.5.5.818.634,6.136.091,9.454.453,15.136.453.545.181,3.273.453,2.091.815a14.1,14.1,0,0,1,3.364-.453c3.409.724-3.954.091-1.318,1,.227-.5,4.545-.679,7.091-1-.773-.77-5.818-.136-8.318.181,0-1.041,4.364-2.128,10.363-2.626,4.773-.272,2.045.679,2.909.543,8.909.181,7.591-1.811,15.045-1.087,2.954.679.136,1.313.773,1.811-3.864.272-5.954-.407-8.591-.407l3.227.317a19.952,19.952,0,0,1-5.227.181c2.455.589,15.091.136,22,.679,1.227-.226,3.318-.453,2.318-.724l-2.182.091c-2-.543,4.091-.724,1.364-1a49.752,49.752,0,0,1,10.318-.679l.773.77a9.375,9.375,0,0,0-3.864-.226c1.727-.317,6.318,1.041,8.182.045l-2.909-.543c2.954-.362,6.545-1.177,10.227-.951-1.682-.724-.864.091-3.454-.77,2.227,1.087-9.318-.045-5.727,1.087-2.682-1-4.591-.407-8.091-1.313.091.226,1.227.5-1.818.362a2.4,2.4,0,0,1-.682.226h-.227a.345.345,0,0,1,.182.045c-.136.045-.136.045.045,0a5.074,5.074,0,0,1,1.545.362c-1.5.589-6.409.543-8.045.86-1.818-.136.773-.272-.227-.543l-2.454.453c-.227-.543-4.818-.905-.545-1.222l-3.864-.045a30.893,30.893,0,0,0-7.318-.181c-1.818-.136-4.591.634-3,.181l-6.045.362-.045-.136c-5.954-.091-12.272.905-19.09-.091a53.281,53.281,0,0,1-7.454.136l-.636-.5c-2.591.181-7.727-.5-8.863,0-2.773-1.268-12.5-.272-17.045-.5l-.182.634c-3.136-.045-6.091.136-10,.407l.227.543c-3.318.453-8.591-.407-13.863-.317a6.956,6.956,0,0,1,2.636-.045,34.962,34.962,0,0,0-9.727-.136,32.877,32.877,0,0,1-4.409.226,2.849,2.849,0,0,1-2.409-1.358,2.273,2.273,0,0,1-1.045-1.856c.045.091.091.136.091.226a3.111,3.111,0,0,1-.136-.362,6.239,6.239,0,0,1,.045-1.313,2.979,2.979,0,0,0-.136,1.087,5.645,5.645,0,0,1-.227-1.313c-.045-.77-.091-1.585-.136-2.4l.591-.679v-.362c.227-1.585-.273-1.268-.727-.453a19.6,19.6,0,0,0-.364-2.173c.955-1.313-.318-4.256.682-6.066-.5-1.087-.364-8.194-1.409-9.054.136-.045.182-.543.227.362a22.452,22.452,0,0,0-.045-5.252l.773-.77-1-3.984c.455-2.4.727-3.4,1.318-1-.909-5.795-.318-4.708-1.227-9.6l.5.226c0-1.766-.682-4.572-.273-5.614.909-3.939.136-19.422,1-29.517-1.455,1.947.636-4.708-.455-5.07.318-.589.545-1.992.818-.362-.318-5.161.545-7.742-.409-11.273.364-.589.5,1.087.682.589a4.925,4.925,0,0,1-.091-2.173c.182-.543.273.77.455,1.585-.045-5.252-1.091-5.795-2.091-6.157a10.638,10.638,0,0,0-.227-5.931c.318-.905.682-2.49.773.77.045-1.856.455-11.227-.318-11.409a5.437,5.437,0,0,0,.136-1.358c.045-.5.091-1,.136-1.177a4.912,4.912,0,0,1,1.955-2.445,7.832,7.832,0,0,1,3.273-1.132,6.739,6.739,0,0,0-.955.045,1.9,1.9,0,0,1,1-.589,2.312,2.312,0,0,1,.591-.091h.773a33.067,33.067,0,0,0,3.954.136l-.091.091c7.5.679,3.227-.317,10.636.453l-.409-.589c.682-1.268,6.545.77,10.863.272L65.581,26.3c2.364-.453,6.545,1.72,8.909,1.9.5.091-.818.181-1.545.272,6.182.77.818-.77,5.409-.951.864.407-1.091,1.041,2,1.132,1.545.317,9-1.358,13.227-.543-.955-.317-1.864-.634.273-.905,3.273-.136,8.863,1.222,11.818.181.409.091.591.181.591.272,2.5-.272,8.136-.453,9.636-1,2.318,2.037,15.591-1,15.5.905l7.727-.091-.182.181c4.909.136,6.682-.317,8.409-.77,1.136.136.318.317.227.407,7.182.362,7.909.317,13.954-.634l.636.589c1.636-.362,10.409.951,17.454.226-.091.091-.227.181-.773.272,7.954-.724,19,1.675,21.909-.543l5.227-.543c-6.773-.181,1-.951-1.773-1.313,2.682-.136,6.909.679,3.636.77l-.5-.091c-1.182,1.177,8.409.407,8.227,1.177,13.318-.045,26.363.589,38.817.634l-1.455-.905,4.364.181c1.136.226,1.545.724-1.591.679a10.345,10.345,0,0,0,5.318-.634c6.091.362-2.364,1.041-.5,1.087l2.545-.045-.591-.091a19.053,19.053,0,0,1,5.954-.724c2.364.181,1.227.543,2.136.589,0,.045.318.091,1.409.045l5.5.091-2.182-.724c2.455-.362,5.182.045,2.636-.77,1.864.634,7,.724,11.909.724,2.454,0,4.909,0,6.863-.045.954,0,1.909,0,2.454.045a3.164,3.164,0,0,1,1.182.226,4.277,4.277,0,0,1,3.409,1.494,5.21,5.21,0,0,1,.955,1.947,4.911,4.911,0,0,1,.227,1.177c0,.226.045.407.045.543v.77c.136-1.041.955-1.63.864,1.947-1.636-1.313-.727,6.564-1.909,9.462.773-2.58.182,10.186,1.318,6.112-.136,2.988-.636.181-1,2.445.636,7.108-.409,15.664-.182,24.447.227.136.545-1.313.864.543l-1.091,4.663c.091,1.72,1.273,1.585.5,4.754.182-.453.455-1.132.545.045-1.045,17.2.864,35.176-1.136,52.7.409-2.354.455-.77.5,1,.091-1.177.546.045.818-.226l-.818,7.334a2.607,2.607,0,0,1,.227.634,2.4,2.4,0,0,1,.045.815,3.878,3.878,0,0,1-.591,1.811c-.682,1.087-1.955,1.675-2.091,2.173a5.2,5.2,0,0,0,1.5-1.041c-.318.543-.273.815.045.86a2.69,2.69,0,0,0,1.591-.362c1.364-.634,2.5-2.445,2.954-2.083,0-.543.045-1.087.045-1.675,0-.543.045-1.087.091-1.675.091-1.087.273-2.309.409-3.576a21.693,21.693,0,0,0-.136-8.194c.227-1.268.364,1.087.636.407-.5-1.449-.591-3.169-.364-6.383l.136.362c-.136-9.009.364-12.9.727-23.043l-.591.77a25.234,25.234,0,0,1,.409-3.667c-.909-2.49-.045,6.112-1.045,3.848,1.182-2.9,0-15.347,1.364-17.339,0-3.35-.682,1-.682-2.354l.364-.905-.455-.86c.091-2.218.546-3.3.864-3.4-.045.543.091,1.494.091,2.083.409-2.852-.136-8.058,0-9.009l-.227,3.214c-.364-9.145.136-20.327-.591-29.155l-.273.679c-.5-6.746.318-5.387.045-12.812l.045.272a28.609,28.609,0,0,1-.364-5.478c.182.951.318.045.5-.77a3.51,3.51,0,0,0,.091-.724.837.837,0,0,1,.091-.453c.045-.181.182-.091.318.815a11.352,11.352,0,0,0-.682-2.9,10.061,10.061,0,0,0-.864-1.72,5.438,5.438,0,0,0-1.273-1.449,9.455,9.455,0,0,0-1.091-.679,10.447,10.447,0,0,0-2.773-1,10.3,10.3,0,0,0-1.136-.815,16.058,16.058,0,0,0-2.318.226c-.773.091-1.682.181-3.545.272,3.045-.407-2.364-.679,1.045-1.222-7.818-1-11.591,1-15.136-.453-3.591,1.268,6.727.679,4.727.951,1.682.407-2.954.951-5.409.815-2.5-.045-4.227-1.63-10.5-1.585.636,0,.682-.091,1.273-.091-2.364-.317-4.591.453-7.454-.091-1.591.77-3.727-.045-4.182.951l5.727-.226c-3.273.272-6.318,1.4-11.682.86a18.744,18.744,0,0,1,3.091-.589c-1.591-.272-3.045.181-4.636-.091.455-1,7-.226,10.5-.951-1.682-.407-6.591.724-4.864-.362-2.5,1.358-6.182-.181-10.409.86l.273-.589A23.72,23.72,0,0,1,244.8,23l2.227-.77c-3.454.634-6.636-.543-9.909-.226,6.909,0,1.545.724,4.454,1.132-8.5.77-4.909-1.539-14.409-1.268,1.273-.091,4.864.362,2.818.634a42.9,42.9,0,0,1-5.318-.634c-6.318.136.955.589-1.727.951-2.136-.724-3.091.272-5.863.5v-.589c-7.182-.362-1.909,1.222-8.363.77l2.727-.815-3.364.226.682-.679a34.957,34.957,0,0,1-8.409.181c.818.407-.455,1.087-3.636,1.087-2.182-.362,1.227-.543-3.318-.5a5.59,5.59,0,0,1,4.091-.272c.182-.181,1-.362,1.227-.543-2.318-.407-5.864-.091-7.5-.091a9.724,9.724,0,0,1,1.773.136l-6.545.815c-1.045-.226-.227-.407.591-.589-1.318.045-2.227.317-4.182.407.5-.5.364-1,3.136-1.222l-6.409.5c-.409-.226-3.182-.589-2.409-.77-3.454-.272-8.5.951-13.091.543a7.536,7.536,0,0,1-1.682.272c-4.318-.091-8.136-.679-13.227-.045l-2.909-.86c-4,.181,3.909,1.087-2.727,1.4-4.727.272-1.773-.724-3.409-1a30.8,30.8,0,0,1-10.772.634c1.454-.136,2.591,0,3.909-.045",
    transform: "translate(-32.264 -24.946)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M333.139,312.4l-2.84.137a11.432,11.432,0,0,1,2.565.183c-.046-.091-.6-.321.275-.321",
    transform: "translate(-179.026 -169.324)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M389.63,320.066c.412-.092.87,0,1.282-.092l-.092-.275c-1.786.046-3.023.229-1.191.366",
    transform: "translate(-210.694 -173.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M342.3,316.429c.229.5,2.015.321,4.03.229h-.366c.6-.687-1.557-.458-3.664-.229",
    transform: "translate(-185.53 -171.384)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M352.1,317.043a12.2,12.2,0,0,1,1.832,0c.229-.275-.733-.046-1.832,0",
    transform: "translate(-190.842 -171.769)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M295.066,313.159c.962.137.6-.641,1.145-.458,1.008-.641-6.366.779-1.145.458",
    transform: "translate(-158.906 -169.396)",
    fill: "#fff"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M343.745,319.681l-.729-.681-1.216.535Z",
    transform: "translate(-185.317 -173.71)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M311.3,319.287l3.206.183c-.046-.092.366-.183.87-.229-1.969,0-4.122-.137-4.076.046",
    transform: "translate(-168.727 -173.006)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M320.2,319.192a19.988,19.988,0,0,0,2.565-.092c-.55,0-1.74,0-2.565.092",
    transform: "translate(-173.552 -172.956)",
    fill: "#fff"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M332.7,320.594l-1.021-.146L329.3,320.4Z",
    transform: "translate(-178.581 -174.429)",
    fill: "#fff"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(16.484 14.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M231.961,319.1l-3.454.181c-.364.226.591.362,1.864.272.864-.136,2.136-.226,1.591-.453",
    transform: "translate(-140.008 -188.309)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M257.336,322.253a5.317,5.317,0,0,1-1.545-.453l-.091.77Z",
    transform: "translate(-154.884 -189.787)",
    fill: "#fff"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M122.2,319.661h.973l-.146-1.362Z",
    transform: "translate(-62.779 -173.351)",
    fill: "#fff"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M627.791,309.9a3.39,3.39,0,0,1-1.191.687,3.6,3.6,0,0,0,1.008-.229,1.926,1.926,0,0,0,.183-.458",
    transform: "translate(-339.624 -167.969)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M622.249,314.387a8.813,8.813,0,0,1-.641-.687c-.321.321-.779.6-1.008.87a9.066,9.066,0,0,1,1.649-.183",
    transform: "translate(-336.372 -170.029)",
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0da600b9.svg";
export { ForwardRef as ReactComponent };